import QueryString from 'qs'

import { getRestRequest } from '../../../helpers/RestHelpers'
import { api } from '../../../configuration'
import { PaginatedResult } from '../../types/PaginatedResult'
import { SArticle } from '../../types/api/Article'

export type ArticlesResponse = PaginatedResult<SArticle>

export type ArticlesParams = {
  page?: number
  locale?: string
  pageSize: number
}

// Fields come from the backend schema at
// betc_amu_careers_backend/src/api/article/content-types/article/schema.json
// Note: v5 removed `image`; article images live under `hero.desktopImage` /
// `hero.mobileImage` (the `blocks.hero` component).
const request = ({ page, locale, pageSize }: ArticlesParams) =>
  `/articles/?${QueryString.stringify(
    {
      fields: '*',
      populate: {
        hero: { populate: '*' },
        tags: true,
        seo: {
          populate: { metaImage: { fields: ['url'] } },
        },
      },
    },
    {
      encodeValuesOnly: true,
    }
  )}` +
  `${page ? `&pagination[page]=${page}` : ''}` +
  `&pagination[pageSize]=${pageSize}` +
  `${locale ? `&locale=${locale}` : ''}`

const getArticles = (page?: number, locale?: string, pageSize = 6) =>
  getRestRequest({
    url: api.REST_API_URL + request({ page, locale, pageSize }),
    transformer: (data: ArticlesResponse): ArticlesResponse => {
      return data
    },
  })

export default getArticles
